import React, { useState, useEffect, useCallback, useRef } from 'react';
import CallNoteModal from '../components/calls/CallNoteModal';
import { callsAPI, operatorsAPI, dispositionsAPI } from '../services/api';
import softphone from '../services/softphone';
import OutcomeSelect from '../components/calls/OutcomeSelect';
import RatingStars from '../components/RatingStars';
import { FiSearch, FiDownload, FiChevronLeft, FiChevronRight, FiFileText, FiPhoneForwarded } from 'react-icons/fi';
import { formatDateTime, formatDuration, getStatusLabel, getDirectionLabel } from '../utils/formatters';

export default function CallLogPage() {
  const [calls, setCalls] = useState([]);
  const [pagination, setPagination] = useState({ total: 0, page: 1, limit: 30, pages: 0 });
  const [operators, setOperators] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noteCall, setNoteCall] = useState(null);
  const [filters, setFilters] = useState({ search: '', status: '', direction: '', operator_id: '', start_date: '', end_date: '' });
  const [codes, setCodes] = useState([]);

  useEffect(() => { dispositionsAPI.codes().then(r => setCodes(r.data.codes || [])).catch(() => {}); }, []);


  const loadCalls = useCallback(async (page = 1) => {
    setLoading(true);
    try {
      const params = { page, limit: 30 };
      Object.entries(filters).forEach(([k, v]) => { if (v) params[k] = v; });
      const res = await callsAPI.list(params);
      setCalls(res.data.calls);
      setPagination(res.data.pagination);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, [filters]);

  useEffect(() => { loadCalls(1); }, [loadCalls]);
  useEffect(() => { operatorsAPI.list().then(r => setOperators(r.data.operators || [])).catch(() => {}); }, []);

  const handleFilter = (key, value) => setFilters(prev => ({ ...prev, [key]: value }));

  
  return (
    <div>
      <div className="page-header">
        <div><h1 className="page-title">Qo'ng'iroqlar jurnali</h1>
          <p className="page-subtitle">Jami: {pagination.total} ta qo'ng'iroq</p></div>
      </div>
      <div className="filters">
        <div style={{ position: 'relative', flex: 1, minWidth: '200px' }}>
          <FiSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
          <input className="input" placeholder="Raqam yoki operator qidirish..." style={{ paddingLeft: '38px' }}
            value={filters.search} onChange={(e) => handleFilter('search', e.target.value)} />
        </div>
        <select className="input" value={filters.status} onChange={(e) => handleFilter('status', e.target.value)}>
          <option value="">Barcha holatlar</option>
          <option value="answered">Javob berildi</option>
          <option value="missed">Javobsiz</option>
          <option value="no_answer">Javobsiz</option>
          <option value="busy">Band</option>
        </select>
        <select className="input" value={filters.direction} onChange={(e) => handleFilter('direction', e.target.value)}>
          <option value="">Barcha yo'nalishlar</option>
          <option value="inbound">Kiruvchi</option>
          <option value="outbound">Chiquvchi</option>
          <option value="internal">Ichki</option>
        </select>
        <select className="input" value={filters.operator_id} onChange={(e) => handleFilter('operator_id', e.target.value)}>
          <option value="">Barcha operatorlar</option>
          {operators.map(op => <option key={op.id} value={op.id}>{op.full_name} ({op.sip_extension})</option>)}
        </select>
        <input className="input" type="date" value={filters.start_date} onChange={(e) => handleFilter('start_date', e.target.value)} />
        <input className="input" type="date" value={filters.end_date} onChange={(e) => handleFilter('end_date', e.target.value)} />
      </div>
      
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {loading ? <div className="loading-center"><div className="spinner" /></div> : (
          <div className="table-wrapper"><table><thead><tr>
            <th>Sana/Vaqt</th><th>Yo'nalish</th><th>Raqam</th><th>Operator</th>
            <th>Davomiylik</th><th>Kutish</th><th>Holat</th><th>Baho</th><th>Natija</th><th>Izoh</th>
                <th>Yozuv</th>
          </tr></thead><tbody>
            {calls.length === 0 ? (
              <tr><td colSpan="11" style={{ textAlign: 'center', padding: '60px', color: 'var(--text-muted)' }}>Qo'ng'iroqlar topilmadi</td></tr>
            ) : calls.map(call => (
              <tr key={call.id}>
                <td style={{ whiteSpace: 'nowrap', fontSize: '13px' }}>{formatDateTime(call.call_date)}</td>
                <td><span className={`badge ${call.direction === 'inbound' ? 'badge-info' : call.direction === 'outbound' ? 'badge-warning' : 'badge-neutral'}`}>
                  {getDirectionLabel(call.direction)}</span></td>
                <td style={{ fontWeight: '600', color: 'var(--text-primary)' }}>
                  <button
                    onClick={() => softphone.triggerCall(call.direction === 'inbound' ? call.caller_number : call.called_number)}
                    title="Qo'ng'iroq qilish uchun bosing"
                    className="clickable-number"
                    style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: 0, fontFamily: 'inherit', textAlign: 'left' }}
                  >
                    <div style={{ fontWeight: 600, color: 'var(--accent, #3b82f6)', textDecoration: 'underline' }}>
                      {call.contact_name || (call.direction === 'inbound' ? call.caller_number : call.called_number)}
                    </div>
                    {call.contact_name && (
                      <div style={{ fontSize: 11, color: 'var(--text-muted)', fontFamily: 'monospace' }}>
                        {call.direction === 'inbound' ? call.caller_number : call.called_number}
                      </div>
                    )}
                  </button>
                </td>
                <td>{call.forwarded
                  ? <span className="badge badge-info" title={`Yo'naltirildi → ${call.forwarding_destination || ''}`}>
                      <FiPhoneForwarded size={11} style={{ marginRight: 4 }} />{call.forwarding_rule || "Yo'naltirildi"}
                    </span>
                  : (call.operator_name || '—')}</td>
                <td>{formatDuration(call.billable_sec || call.duration)}</td>
                <td style={{ color: 'var(--text-muted)' }}>{formatDuration(call.wait_time)}</td>
                <td><span className={`badge ${call.status === 'answered' ? 'badge-success' : call.status === 'busy' ? 'badge-warning' : 'badge-danger'}`}>
                  <span className="badge-dot" />{getStatusLabel(call.status)}</span></td>
                <td><RatingStars value={call.rating} /></td>
                <td><OutcomeSelect call={call} codes={codes} onChanged={() => loadCalls(pagination.page)} /></td>
                <td>
                    <button
                      className="btn btn-ghost btn-icon"
                      onClick={() => setNoteCall(call)}
                      style={{ 
                        color: call.notes ? 'var(--accent, #3b82f6)' : 'var(--text-muted)',
                        position: 'relative'
                      }}
                      title={call.notes ? 'Izohni ko\'rish' : 'Izoh qo\'shish'}
                    >
                      <FiFileText size={15} />
                      {call.notes && (
                        <span style={{
                          position: 'absolute', top: 2, right: 2,
                          width: 6, height: 6, borderRadius: '50%',
                          background: '#3b82f6'
                        }} />
                      )}
                    </button>
                  </td>
                  <td>{call.has_recording && call.status === 'answered' ? (
                  <a href={callsAPI.downloadRecording(call.id)} className="btn btn-ghost btn-icon" target="_blank" rel="noreferrer" title="Yuklab olish">
                    <FiDownload size={15} />
                  </a>
                ) : <span style={{ color: 'var(--text-tertiary)' }}>—</span>}</td>
              </tr>
            ))}</tbody></table></div>
        )}
      </div>
      {pagination.pages > 1 && (
        <div className="pagination">
          <button disabled={pagination.page <= 1} onClick={() => loadCalls(pagination.page - 1)}><FiChevronLeft size={14} /></button>
          {Array.from({ length: Math.min(pagination.pages, 7) }, (_, i) => {
            let p = pagination.pages <= 7 ? i + 1 : pagination.page <= 4 ? i + 1 : pagination.page >= pagination.pages - 3 ? pagination.pages - 6 + i : pagination.page - 3 + i;
            return <button key={p} className={p === pagination.page ? 'active' : ''} onClick={() => loadCalls(p)}>{p}</button>;
          })}
          <button disabled={pagination.page >= pagination.pages} onClick={() => loadCalls(pagination.page + 1)}><FiChevronRight size={14} /></button>
        </div>
      )}
      {noteCall && (
        <CallNoteModal 
          call={noteCall} 
          onClose={() => setNoteCall(null)}
          onSave={() => loadCalls(pagination.page)}
        />
      )}
    </div>
  );
}
